import { z } from "zod";

const fileSizeLimit = 50 * 1024 * 1024;
const videoSizeLimit = 50 * 1024 * 1024;
const fileSchema = z
  .instanceof(File, { message: "form:cvError" })
  .refine((file) => {
    return [
      "application/pdf", 
      "application/docx",  
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ].includes(file.type)}, {
    message: "form:cvError",
  })
  .refine((file) => file.size <= fileSizeLimit, {
    message: "form:uploadDocLimit",
  });

const optionalFileSchema = z
  .any()
  .optional()
  .refine((file) => (file ? 
  [
    "application/pdf", 
    "application/docx", 
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  ].includes(file.type) : true), {
    message: "form:invalidDocType",
  })
  .refine((file) => (file ? file.size <= fileSizeLimit : true), {
    message: "form:uploadDocLimit",
  });
const optionalVideoSchema = z
  .any()
  .optional()
  .refine(
    (file) =>
      file
        ? ["video/mp4", "video/mov", "video/quicktime"].includes(file.type)
        : true,
    { message: "form:invalidVideoType" }
  )
  .refine((file) => (file ? file.size <= videoSizeLimit : true), {
    message: "form:uploadVideoLimit",
  });

export const schema = z.object({
  name: z.string().nonempty("form:nameError"),
  email: z.string().email("form:emailError"),
  phone_number: z.string().nonempty("form:phoneNumberError"),
  cv_file: fileSchema,
  video_cv_file: optionalVideoSchema,
  other_document_file: optionalFileSchema,
  terms: z.boolean().refine((val) => val === true, {
    message: "form:termsError",
  }),
  message: z.string().max(100).optional()
});
